module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("7C4Cq"))).then(() => parcelRequire('2Psbj'));